export enum PowderFinish {
	Matt = 0,
	Glossy = 1,
}
